import React from "react";
import BottomNavigation, {
  BottomNavigationAction
} from "material-ui/BottomNavigation";
import { Button, Paper, Checkbox } from "material-ui";
import { FormControlLabel } from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import SelectSurveyContainer from "containers/CreateSurvey/BaseInfo/SelectSurveyContainer";

import { STATUS as SURVEY_STATUS } from "models/Survey";
import { isAdmin, convertLocaleKeyToName } from "utils/formatter";
import CInput from "uis/CInput";
import ErrorMessage from "components/ErrorMessage";
import DatePicker from "uis/Datepicker";
import storage from "utils/storage";

import FreeCommentArea from "./FreeCommentArea";

const styles = theme => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
    position: "relative"
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0,
    flex: 1,
    color: "#575962"
  },
  main: {
    padding: 20,
    marginBottom: 10
  },
  subTitle: {
    color: "#575962",
    display: "inline-block",
    width: 150,
    marginRight: 50,
    fontSize: "1.4rem"
  },
  buttons: {
    position: "absolute",
    right: 40,
    left: 40,
    bottom: 20
  },
  clear: {
    clear: "both"
  },
  cancelBtn: {
    marginRight: 10
  },
  registBtn: {
    marginRight: 10
  },
  actionBtn: {
    marginRight: 10,
    width: 225
  },
  errorMessage: {
    fontSize: ".9rem",
    marginBottom: 10
  },
  paperDesc: {
    color: "#9699a2",
    fontSize: "1.1em"
  },
  removeButton: {
    backgroundColor: theme.palette.remove.dark,
    "&:hover": {
      backgroundColor: theme.palette.remove.light,
      boxShadow: "2px 3px 7px rgba(0,0,0,0.4);"
    }
  },
  basicInfoRow: {
    display: "flex"
  },
  basicInfoRowEmps: {
    flex: 0.4
  },
  basicInfoRowAdditions: {
    flex: 0.4
  },
});

class BaseInfo extends React.Component {
  componentWillMount() {
    if (storage.isReloaded()) {
      storage.removeReloaded();
    }
    if (this.isNew()) {
      if (!this.props.baseInfo.init) this.props.fetchSurveyDetail();
    } else {
      this.props.fetchSurveyDetail();
    }
    window.scroll(0, 0);
    window.addEventListener("beforeunload", this.showReloadAlert);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.showReloadAlert);
  }


  showReloadAlert(e) {
    e.returnValue = "行った変更が保存されない可能性があります。";
  }

  naviStyle(localeNo) {
    return this.props.baseInfo.localeNo === localeNo
      ? { color: "#fff", backgroundColor: "#26a69a" }
      : { color: "#333", backgroundColor: "transparent" };
  }

  isNew() {
    const { pathname } = window.location;
    return pathname.indexOf("/create_survey/") > -1;
  }

  render() {
    const { classes, baseInfo, customer, survey, errors } = this.props;

    return (
      <Paper className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>
            アンケート{this.isNew() ? "登録" : "更新"}
          </h2>
          {isAdmin() &&
            survey.status === SURVEY_STATUS.READY && (
              <Button
                className={classes.removeButton}
                raised
                style={{ float: "right" }}
                onClick={this.props.handleDelete}
              >
                削除
              </Button>
            )}
        </div>

        <div className={classes.main}>
          <ErrorMessage messages={errors} className={classes.errorMessage} />
          <div style={{ marginBottom: "1rem" }}>
            <h3 className={classes.subTitle}>基本情報</h3>
            {isAdmin() && (
              <Button
                disabled={survey.status >= SURVEY_STATUS.OPEN}
                raised
                style={{ float: "right" }}
                onClick={this.props.openSelectSurveyModal}
              >
                過去の設定を利用
              </Button>
            )}
            <SelectSurveyContainer />
            <div>
              <div
                className={classes.paperDesc}
                style={{ width: 100, display: "inline-block" }}
              >
                顧客名
              </div>
              <span>
                {`${customer.customerName}（ID:${customer.customerKey}）`}
              </span>
            </div>
            <div>
              <div
                className={classes.paperDesc}
                style={{ width: 100, display: "inline-block" }}
              >
                使用言語*
              </div>
              {baseInfo.canUseLocales.map(locale => {
                return (
                  <FormControlLabel
                    key={locale.key}
                    control={
                      <Checkbox
                        checked={baseInfo.useLocales.indexOf(locale.key) > -1}
                        classes={{
                          checked: classes.checked
                        }}
                        value={locale.key}
                        disabled={survey.isOpened()}
                        onChange={event =>
                          this.props.changeUseLocales(event, locale.key)
                        }
                      />
                    }
                    label={locale.jaLabel}
                  />
                );
              })}
            </div>

            <div className={classes.basicInfoRow}>
              <div className={classes.basicInfoRowEmps}>
                <div
                  className={classes.paperDesc}
                  style={{
                    marginRight: 23,
                    display: "inline-block"
                  }}
                >
                  対象者数*
                </div>
                {isAdmin() && survey.status < SURVEY_STATUS.OPEN ? (
                  <CInput
                    value={baseInfo.employees}
                    inputProps={{
                      maxLength: 5,
                      style: { width: 100, textAlign: "right" }
                    }}
                    type="number"
                    onChange={e => {
                      if (e.target.value.length > 5) return;
                      this.props.changeItem("employees", e.target.value);
                    }}
                  />
                ) : (
                  <span>{baseInfo.employees}</span>
                )}
              </div>
              <div className={classes.basicInfoRowAdditions}>
                <div
                  className={classes.paperDesc}
                  style={{
                    marginRight: 23,
                    display: "inline-block"
                  }}
                >
                  追加設問数*
                </div>
                {isAdmin() && survey.status < SURVEY_STATUS.OPEN ? (
                  <CInput
                    value={baseInfo.additionLimit}
                    inputProps={{
                      maxLength: 2,
                      style: { width: 100, textAlign: "right" }
                    }}
                    type="number"
                    onChange={e => {
                      if (e.target.value.length > 2) return;
                      this.props.changeItem("additionLimit", e.target.value);
                    }}
                  />
                ) : (
                  <span>{baseInfo.additionLimit}</span>
                )}
              </div>
              {isAdmin() && (
                <div>
                  <span className={classes.paperDesc} style={{ marginRight: 20 }}>回答方式</span>
                </div>
              )}
              {isAdmin() && (
                <div>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={!!this.props.isMailSendToEmployee}
                          onChange={(e) => {
                            const isMailSendToEmployeeChecked = e.target.checked;
                            this.props.setMailSendToIndividual(isMailSendToEmployeeChecked);
                          }}
                          disabled={survey.status >= SURVEY_STATUS.OPEN}
                          style={{ height: 30 }}
                        />
                      }
                      label={
                        <div className={classes.paperDesc}>
                          回答者特定方式
                        </div>
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <Paper style={{ marginBottom: 20 }}>
            {/* 言語タブ */}
            <div>
              <BottomNavigation
                style={{ justifyContent: "left" }}
                value={baseInfo.localeNo}
                onChange={this.props.changeLocale}
                showLabels
              >
                {baseInfo.useLocales.map(locale => (
                  <BottomNavigationAction
                    key={locale}
                    style={this.naviStyle(locale)}
                    value={locale}
                    label={convertLocaleKeyToName(locale)}
                  />
                ))}
              </BottomNavigation>
            </div>

            <div>
              {baseInfo.localeNo ? (
                <div style={{ padding: 20 }}>
                  <div style={{ marginBottom: 10, display: "flex" }}>
                    <span
                      className={classes.paperDesc}
                      style={{ display: "inline-block", width: 160 }}
                    >
                      アンケート名*
                    </span>
                    <CInput
                      style={{ width: 800 }}
                      inputProps={{ maxLength: 50 }}
                      value={baseInfo.items[baseInfo.localeNo].surveyName}
                      onChange={e =>
                        this.props.changeLocaleItem(
                          "surveyName",
                          e.target.value,
                          baseInfo.localeNo
                        )
                      }
                    />
                  </div>

                  <div className={classes.paperDesc}>
                    <span style={{ display: "inline-block", width: 160 }}>
                      アンケートの説明*
                    </span>
                    <div
                      className={classes.paperPeriod}
                      style={{
                        marginBottom: 10,
                        display: "inline-block"
                      }}
                    >
                      <CInput
                        style={{ width: 800 }}
                        inputProps={{ maxLength: 255 }}
                        value={baseInfo.items[baseInfo.localeNo].surveyExplain}
                        multiline
                        rows="6"
                        onChange={e =>
                          this.props.changeLocaleItem(
                            "surveyExplain",
                            e.target.value,
                            baseInfo.localeNo
                          )
                        }
                      />
                    </div>
                  </div>

                  <FreeCommentArea
                    required
                    isOpened={survey.isOpened()}
                    label="自由記入１の説明"
                    freeCommentDescription={
                      baseInfo.items[baseInfo.localeNo].freeCommentDescription1
                    }
                    onChangeTextField={text =>
                      this.props.changeLocaleItem(
                        "freeCommentDescription1",
                        text,
                        baseInfo.localeNo
                      )
                    }
                  />

                  <FreeCommentArea
                    isOpened={survey.isOpened()}
                    label="自由記入２の説明"
                    freeCommentDescription={
                      baseInfo.items[baseInfo.localeNo].freeCommentDescription2
                    }
                    freeCommentCheck={baseInfo.freeCommentCheck2}
                    onChangeTextField={text =>
                      this.props.changeLocaleItem(
                        "freeCommentDescription2",
                        text,
                        baseInfo.localeNo
                      )
                    }
                    onChangeCheckBox={this.props.changeFreeCommentCheckbox2}
                  />
                </div>
              ) : (
                <div style={{ padding: 20, height: 217, color: "red" }}>
                  アンケートで使用する言語を選択してください。
                </div>
              )}
            </div>
          </Paper>
          <div style={{ display: "flex", marginBottom: 20 }}>
            <div className={classes.paperDesc} style={{ marginRight: 30 }}>
              公開期間*
            </div>
            <DatePicker
              selectedDate={baseInfo.termFrom}
              onChange={date => this.props.changeTerm("termFrom", date)}
            />
            <span style={{ margin: "0 20px", paddingTop: 3 }}>〜</span>
            <DatePicker
              selectedDate={baseInfo.termTo}
              onChange={date => this.props.changeTerm("termTo", date)}
            />
            {isAdmin() &&
            <div style={{ display: "flex", marginBottom: 20, marginLeft: 5, alignItems: 'center' }}>
              <Checkbox
                checked={this.props.isChecked}
                onChange={(e) => {
                  const { checked } = e.target;
                  const newAlertDays = checked ? this.props.alertDays : '';
                  this.props.setAlertConfig(newAlertDays, checked);
                }}
                style={{ height: 30 }}
              />
              <span style={{ marginRight: 7 }}>アラート</span>
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: '25px' }}>
                <span> アンケート終了 </span>
                <input
                  type="number"
                  min="0"
                  value={this.props.alertDays}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (value === '' || parseInt(value, 10) >= 0) {
                      this.props.setAlertConfig(value, this.props.isChecked);
                    }
                  }}
                  disabled={!this.props.isChecked}
                  style={{
                    width: 40,
                    marginLeft: 4,
                    marginRight: 4,
                    height: '1.7rem',
                    paddingLeft: 8,
                    border: "1px solid #ced4da",
                    borderRadius: 4,
                    textAlign: 'right',
                    fontSize: '16px'
                  }}
                />
                <span>日前</span>
              </div>
            </div>
            }
          </div>
        </div>
        <div className={classes.buttons}>
          {this.isNew() && (
            <div style={{ position: "absolute" }}>
              <Button
                style={{ froat: "left" }}
                raised
                className={classes.cancelBtn}
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                キャンセル
              </Button>
            </div>
          )}
          <div style={{ textAlign: "center" }}>
            {this.isNew() ? (
              <div>
                <div
                  className={classes.actionBtn}
                  style={{ display: "inline-block" }}
                />
                <Button
                  raised
                  className={classes.actionBtn}
                  onClick={() => {
                    this.props.handleNext({
                      survey: this.props.survey,
                      baseInfo: this.props.baseInfo,
                      alertDays: this.props.alertDays,
                      isChecked: this.props.isChecked,
                      isMailSendToEmployee: this.props.isMailSendToEmployee
                    });
                  }}
                >
                  次（属性選択）へ
                </Button>
              </div>
            ) : (
              <div>
                <Button
                  style={{ froat: "left" }}
                  raised
                  className={classes.cancelBtn}
                  onClick={() => {
                    this.props.history.goBack();
                  }}
                >
                  キャンセル
                </Button>
                <Button
                  raised
                  onClick={() => {
                    this.props.handleUpdate({
                      survey: this.props.survey,
                      baseInfo: this.props.baseInfo,
                      selectAttr: this.props.selectAttr,
                      baseWord: this.props.baseWord,
                      additions: this.props.additions,
                      alertDays: this.props.alertDays,
                      isChecked: this.props.isChecked,
                      isMailSendToEmployee: this.props.isMailSendToEmployee
                    });
                  }}
                >
                  更新
                </Button>
              </div>
            )}
          </div>
          {this.isNew() && (
            <div style={{ position: "absolute", top: 0, right: 0 }}>
              <Button
                raised
                className={classes.registBtn}
                onClick={() => {
                  this.props.handleRegist({
                    survey: this.props.survey,
                    baseInfo: this.props.baseInfo,
                    selectAttr: this.props.selectAttr,
                    baseWord: this.props.baseWord,
                    additions: this.props.additions,
                    alertDays: this.props.alertDays,
                    isChecked: this.props.isChecked,
                    isMailSendToEmployee : this.props.isMailSendToEmployee
                  });
                }}
              >
                登録
              </Button>
            </div>
          )}
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(BaseInfo);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/BaseInfo/index.jsx